import { IQuiz, Quiz } from '@fmnts/api';

/**
 * Status for attempts
 */
export type NextQuizStatus = Readonly<{
  /** Amount of failed attempts */
  failedAttempts: number;
  /** Amount of succesful attempts */
  successfulAttempts: number;
  /** If quiz attempts are expired  */
  isExpired: boolean;
}>;

/**
 * Next Quiz
 * Extends the Quiz-Interface by also including the status information
 * regarding attempts.
 *
 * @see {@link Quiz}
 */
export interface INextQuiz {
  quiz: IQuiz;
  status: NextQuizStatus;
}

export class NextQuiz implements INextQuiz {
  public quiz: Quiz;
  public status: NextQuizStatus;

  constructor(dto: Readonly<INextQuiz>) {
    this.quiz = new Quiz(dto.quiz);
    this.status = dto.status;
  }
}
